'use client'
import * as React from 'react'
import Modal from 'react-modal'
import classes from './styles.module.css'
// import closeImg from 'assets/icons/home-page/close.svg'
import {IoClose} from 'react-icons/io5'
import heroImage from 'assets/icons/home-page/Video-thumbnail.jpg'

interface VideoModalProps {
  isOpen: boolean
  setOpen: any
}
export default function VideoModal({isOpen, setOpen}: VideoModalProps) {
  const videoUrl = 'https://hybrid-prod-eu.s3.eu-central-1.amazonaws.com/ZenAdmin+01.mp4'
  const customStyles = {
    overlay: {
      zIndex: 300,
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
    },
    content: {
      top: 0,
      left: '0',
      zIndex: '100000000',
      height: '100vh',
      width: '100vw',
      background: 'white',
      padding: 0,
    },
  }
  return (
    <Modal isOpen={isOpen} style={customStyles}>
      <div className={classes.content}>
        <div className={classes.closeIconContainer} onClick={() => setOpen(false)}>
          <IoClose color="rgba(0, 0, 0, 0.56)" size={27} />
          {/* <Image src={closeImg} alt='close' className={ classes.closeIcon} /> */}
        </div>
        <video
          className={classes.video}
          controls
          autoPlay
          loop
          preload="auto"
          playsInline
          poster={heroImage.src}
        >
          <source src={videoUrl} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    </Modal>
  )
}
